import React from "react";
import { Container, Sessao } from "./styles";

import DestaquePrincipal from "../../../NoticiaCard/Destaque/Principal";

function MainHighlight(props) {
  return (
    <Sessao>
      <Container>
        {props.noticias ? (
          <DestaquePrincipal
            categorias={props.noticias.categorias}
            img={props.noticias.noticia_img_path}
            previa={props.noticias.previa_texto}
            titulo={props.noticias.titulo}
            data={props.noticias.data_de_publicacao}
            to={`/noticias/${props.noticias.id}`}
          />
        ) : (
          "Sem notícias cadastradas."
        )}
      </Container>
    </Sessao>
  );
}

export default MainHighlight;
